define.alias("shared/components/shared/post-tagging/select/tag-select-multiple", "calendar/components/shared/post-tagging/select/tag-select-multiple");